import * as React from 'react';
import { Button, Modal } from 'src/shared/ui/elements';
import { detectPlatform } from '../class-details/hooks/useMobileAppVersion';

export const AppUpdateModal = () => {
  const handleStore = () => {
    const platform = detectPlatform();
    if (platform === 'iOS') {
      window.open(`https://apps.apple.com/app/6480411503`, '_blank');
    }
    if (platform === 'Android') {
      window.open(`market://details?id=com.yaucoachportal`, '_blank');
    }
  };
  return (
    <Modal $title="It's time to update" showClose={false}>
      <Modal.Content>
        <div className="p-24 pt-32 pb-32 h-full">
          <div className="flex align-center justify-space-between m-16">
            <div>
              <p className="fs-12">
                A new version of the app is available, please update to get
                access to the new features
              </p>
            </div>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer className="flex align-center justify-flex-end">
        <Button className="btn btn-primary" onClick={handleStore} type="button">
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
